<template>
<div>
  <div class="goods-sku-swap" v-for="(item,index) in list" >
    <div class="block">
      <label class="label inline-block r-top business-name">
        <i class="fa fa-shopping-bag business-icon" aria-hidden="true"></i>{{item.userInfo.userName}}
      </label>
    </div>
    <div class="block" v-if="handleType != 3">
      <label class="label inline-block r-top">设置店铺折扣：</label>
      <input type="number" class="input cyzs-w-200" v-model="item.discount">
      <button class="button is-info" @click="setBusinessDiscount(index)">设置</button>
    </div>
    <div class="block">
      <table class="table is-bordered">
        <thead>
          <tr>
            <th>商品信息</th>
            <th>商品名称</th>
            <th>商品图</th>
            <th>SKU</th>
            <th>商品库存</th>
            <th>原价</th>
            <th>现价</th>
            <th>折扣（折）</th>
            <th>限时折扣价（￥）</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(goodItem,goodIndex) in item.goodsList">
            <tr>
              <td>{{goodItem.goodsId}}</td>
              <td>{{goodItem.name}}</td>
              <td>
                <image-component :image="goodItem.image" :width="100" :height="100"></image-component>
              </td>
              <td>
                <div v-if="goodItem.skuCount > 1" class="cursor" @click="onToggle(index,goodIndex)">
                  <div v-if="goodItem.isShow">
                    <p class='arrow-text'>收起</p>
                    <i class="fa fa-arrow-up arrow-icon" aria-hidden="true"></i>
                  </div>
                  <div v-else>
                    <p class="arrow-text">展开</p>
                    <i class="fa fa-arrow-down arrow-icon" aria-hidden="true"></i>
                  </div>
                </div>
                <div v-else>
                  『{{goodItem.skuList[0].color}}』『{{goodItem.skuList[0].size}}』
                </div>
              </td>
              <td>{{goodItem.stock}}</td>
              <td>￥{{goodItem.originalPrice}}</td>
              <td>￥{{goodItem.price}}</td>
              <td>
                <input v-if="handleType != 3" type="text" class="input" v-model="goodItem.discount" @blur="onBlurGoodDiscount(index,goodIndex)">
                <span v-else>{{goodItem.discount}}折</span>
              </td>
              <td>
                <input v-if="handleType != 3" type="text" class="input" v-model="goodItem.discountPrice" @blur="onBlurGoodDiscountPrice(index,goodIndex)">
                <span v-else>￥{{goodItem.discountPrice}}</span>
              </td>
              <td>
                <p><button class="button is-danger" @click="onDeleteGood(index,goodIndex)">删除</button></p>
                <p class="margin-top"><a class="button is-warning" :href="'/admin.php?method=goods.view&goodsId='+goodItem.goodsId">库存</a></p>
              </td>
            </tr>
            <tr v-if="goodItem.isShow" v-for="(skuItem, skuIndex) in goodItem.skuList">
              <td></td>
              <td></td>
              <td></td>
              <td class="text-center">『{{skuItem.color}}』『{{skuItem.size}}』</td>
              <td>{{skuItem.stock}}</td>
              <td>￥{{skuItem.originalPrice}}</td>
              <td>￥{{skuItem.price}}</td>
              <td>
                <span v-if="handleType != 3"><input type="text" class="input" v-model="goodItem.discount" @blur="onBlurSkuDiscount(index,goodIndex,skuIndex)"></span>
                <span v-else>{{skuItem.discount}}折</span>
              </td>
              <td>
                <span v-if="handleType != 3"><input type="text" class="input" v-model="goodItem.discountPrice" @blur="onBlurSkuDiscountPrice(index,goodIndex,skuIndex)"></span>
                <span v-else>￥{{skuItem.discountPrice}}</span>
              </td>
              <td></td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
  </div>
</div>
</template>
<script type="text/ecmascript-6">
  export default {
    data(){
      return{
        currGoodsIds:[]//用来存储已经在列表中的商品ID
      }
    },
    props:{
      goodsData:{
        type:Array,
        default:[]
      },
      list:{
        type:Array,
        default:[]
      },
      handleType:{
        type:[Number,String],
        default:1
      },
      id:{
        type:[Number,String],
        default:''
      }
    },
    watch:{
      goodsData(){
        _.each(this.goodsData,(actvItem,index)=>{
          _.each(actvItem.goodsList,(goodItem,goodIndex)=>{
            if(this.currGoodsIds.indexOf(goodItem.goodsId.trim()) > -1){
              this.$message('商品ID有重复!已过滤',2000)
              delete actvItem.goodsList[goodIndex]
            }
            goodItem.isShow = false
          })
          _.each(this.list,(item,index)=>{
            if(actvItem.userInfo.userId == item.userInfo.userId){ //遍历当前是否有已经存在的相同商家
              //将相同商家的商品进行合并
              item.goodsList = _.toArray(item.goodsList).concat(_.toArray(actvItem.goodsList))
              actvItem.isHasBusiness = true                        //将已经合并的商家打上标记
            }
          })
          if(!actvItem.isHasBusiness){                             //如果不存在该标记，则新增一个商家
            this.list.push(actvItem)
          }
        })
        _.each(this.list,(item,index)=>{
          _.each(item.goodsList,(goodItem,goodIndex)=>{
            if(this.currGoodsIds.indexOf(goodItem.goodsId.trim()) < 0){
              this.currGoodsIds.push(goodItem.goodsId.trim())
            }
          })
        })
      }
    },
    mounted(){
    },
    methods:{
      UPDATE_ALL_DISCOUNT(list){
        _.each(list,(item,index)=>{
          _.each(item.goodsList,(goodItem,goodIndex)=>{
            this.onBlurGoodDiscount(index,goodIndex)
          })
        })
      },
      /**
       * Sku显示／隐藏切换
       * @param index
       */
      onToggle(index,goodIndex){
        let temp = JSON.parse(JSON.stringify(this.list))
        temp[index].goodsList[goodIndex].isShow = !temp[index].goodsList[goodIndex].isShow
        this.list[index].goodsList = temp[index].goodsList
      },
      /**
       * 焦点离开商品限时折扣input,计算商品限时折扣价格，并同步到sku
       * @param actvIndex 活动索引
       * @param goodIndex 商品索引
       */
      onBlurGoodDiscount(actvIndex,goodIndex){
        let goodItem = this.list[actvIndex].goodsList[goodIndex],
            originPrice = goodItem.originalPrice*1,
            discount = goodItem.discount*1,
            discountPrice = (originPrice*discount/10).toFixed(2)*1,
            price = goodItem.price*1
        if(discount < 0 || discount > 10){
          this.$message('折扣必须在0～10之间！')
          goodItem.discount = ''
          goodItem.discountPrice = ''
          return false;
        }else if(discountPrice > price){
          this.$message('您当前折扣价大于现价，请重现设置！')
          goodItem.discount = ''
          goodItem.discountPrice = ''
          return false;
        }
        goodItem.discountPrice = discountPrice.toFixed(2)
        goodItem.discount = discount.toFixed(1)
        _.each(goodItem.skuList,(skuItem,skuIndex)=>{
          skuItem.discount = discount.toFixed(1)
          skuItem.discountPrice = discountPrice.toFixed(2)
        })
      },
      /**
       * 焦点离开商品限时折扣价格input,计算商品限时折扣，并同步到sku
       * @param actvIndex 活动索引
       * @param goodIndex 商品索引
       */
      onBlurGoodDiscountPrice(actvIndex,goodIndex){
        let goodItem = this.list[actvIndex].goodsList[goodIndex],
            originPrice = goodItem.originalPrice*1,
            discountPrice = goodItem.discountPrice*1,
            discount = (discountPrice / originPrice * 10).toFixed(4)*1,
            price = goodItem.price*1
        if(discount < 0 || discount > 10){
          this.$message('折扣必须在0～10之间！')
          goodItem.discount = ''
          goodItem.discountPrice = ''
          return false;
        }else if(discountPrice > price){
          this.$message('您当前折扣价大于现价，请重现设置！')
          goodItem.discount = ''
          goodItem.discountPrice = ''
          return false;
        }
        goodItem.discountPrice = discountPrice.toFixed(2)
        goodItem.discount = discount.toFixed(1)
        _.each(goodItem.skuList,(skuItem,skuIndex)=>{
          skuItem.discount = discount.toFixed(1)
          skuItem.discountPrice = discountPrice.toFixed(2)
        })
      },
      /**
       * 焦点离开SKU限时折扣input,计算SKU限时折扣价格
       * @param actvIndex 活动索引
       * @param goodIndex 商品索引
       * @param skuIndex  SKU索引
       */
      onBlurSkuDiscount(actvIndex,goodIndex,skuIndex){
        let skuItem = this.list[actvIndex].goodsList[goodIndex].skuList[skuIndex],
          originPrice = skuItem.originalPrice*1,
          discount = skuItem.discount*1,
          discountPrice = (originPrice*discount/10).toFixed(2)*1,
          price = skuItem.price*1
        if(discount < 0 || discount > 10){
          this.$message('折扣必须在0～10之间！')
          skuItem.discount = ''
          skuItem.discountPrice = ''
          return false;
        }else if(discountPrice > price){
          this.$message('您当前折扣价大于现价，请重现设置！')
          skuItem.discount = ''
          skuItem.discountPrice = ''
          return false;
        }
        skuItem.discount = discount.toFixed(1)
        skuItem.discountPrice = discountPrice.toFixed(2)
      },
      /**
       * 焦点离开SKU限时折扣价格input,计算SKU限时折扣
       * @param actvIndex 活动索引
       * @param goodIndex 商品索引
       * @param skuIndex  SKU索引
       */
      onBlurSkuDiscountPrice(actvIndex,goodIndex,skuIndex){
        let skuItem = this.list[actvIndex].goodsList[goodIndex].skuList[skuIndex],
          originPrice = skuItem.originalPrice*1,
          discountPrice = skuItem.discountPrice*1,
          discount = (discountPrice / originPrice * 10).toFixed(4)*1,
          price = skuItem.price*1
        if(discount < 0 || discount > 10){
          this.$message('折扣必须在0～10之间！')
          skuItem.discount = ''
          skuItem.discountPrice = ''
          return false;
        }else if(discountPrice > price){
          this.$message('您当前折扣价大于现价，请重现设置！')
          skuItem.discount = ''
          skuItem.discountPrice = ''
          return false;
        }
        skuItem.discount = discount.toFixed(1)
        skuItem.discountPrice = discountPrice.toFixed(2)
      },
      /**
       * 设置店铺折扣
       * @param index
       */
      setBusinessDiscount(index){
        let goodsList = this.list[index].goodsList,
            discount = this.list[index].discount
        _.each(goodsList,(goodItem,goodIndex)=>{
          goodItem.discount = discount
          this.onBlurGoodDiscount(index,goodIndex)
        })
        this.list[index].discount = ''
      },
      /**
       * 删除商品
       */
      onDeleteGood(actvIndex,goodIndex){
        if(!confirm('确定删除？')){
          return false;
        }
        let list = this.list,
            goodsId = this.list[actvIndex].goodsList[goodIndex].goodsId,
            currGoodsIndex = this.currGoodsIds.indexOf(goodsId)
        if(this.handleType == 1){  //1:新建  直接删除即可，无需调接口
          list[actvIndex].goodsList = _.toArray(list[actvIndex].goodsList)
          list[actvIndex].goodsList.splice(goodIndex,1)
          this.$set(this.list,actvIndex,list[actvIndex])
          this.currGoodsIds.splice(currGoodsIndex,1)
          this.$message('删除成功！')
        }else{
          let params = {
            timeLimitId:this.id,
            goodsId:this.list[actvIndex].goodsList[goodIndex].goodsId
          }
          HttpRequest.post('/admin.php?method=timelimit.removeGoods',params).then(response => {
            if(response.data.result){
              this.$message('删除成功！')
              list[actvIndex].goodsList = _.toArray(list[actvIndex].goodsList)
              list[actvIndex].goodsList.splice(goodIndex,1)
              this.currGoodsIds.splice(currGoodsIndex,1)
              this.$set(this.list,actvIndex,list[actvIndex])
            }
          })
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .goods-sku-swap {
    .business-name {
      font-size: 18px;
      .business-icon {
        color:#d075ea;
        font-size: 20px;
        margin-right: 10px;
      }
    }
    .arrow-text,.arrow-icon {
      position: relative;
      left: 50%;
      color:#d075ea;
      cursor: pointer;
    }
    .arrow-text {
      margin-left: -12px;
    }
    .arrow-icon {
      margin-left: -6px;
      top:5px;
    }
  }
</style>
